import { Controller, useFormContext } from 'react-hook-form';
import { DashboardPageFormField } from '@shigo-ui/dashboard-ui';
import { Switch } from '@shigo-ui/ui';

import type { DemandPartnerFormValue } from '../../formSchema';

type BooleanFieldName = {
  [Key in keyof DemandPartnerFormValue]: DemandPartnerFormValue[Key] extends boolean ? Key : never;
}[keyof DemandPartnerFormValue] &
  string;

export function FormSwitchField(props: { name: BooleanFieldName; label: string; hint?: string }) {
  const { control } = useFormContext<DemandPartnerFormValue>();
  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field }) => (
        <DashboardPageFormField label={props.label} hint={props.hint}>
          <div className="border-input flex h-10 items-center justify-between rounded-md border px-3">
            <span className="text-sm">{field.value ? 'Enabled' : 'Disabled'}</span>
            <Switch
              checked={field.value}
              onCheckedChange={field.onChange}
              aria-label={props.label}
            />
          </div>
        </DashboardPageFormField>
      )}
    />
  );
}
